<!--
<template>
  <div :class="[prefixCls]">
    <ul>
      <slot></slot>
      <template v-for="item in filterEmpty($slots.default).slice(0, 3)"></template>

      <template v-if="maxLength > 0 && filterEmpty($slots.default).length > maxLength">
        <avatar-item :size="size">
          <avatar :size="size !== 'mini' && size || 20" :style="excessItemsStyle">{{ `+${maxLength}` }}</avatar>
        </avatar-item>
      </template>
    </ul>
  </div>
</template>
-->

<script lang="jsx">
import Avatar from 'ant-design-vue/es/avatar'
import AvatarItem from './Item'
import { filterEmpty } from '@/components/_util/util'

export default {
  AvatarItem,
  name: 'AvatarList',
  components: {
    Avatar,
    AvatarItem
  },
  props: {
    prefixCls: {
      type: String,
      default: 'ant-pro-avatar-list'
    },
    /**
       * 头像大小 类型: large、small 、mini, default
       * 默认�? default
       */
    size: {
      type: [String, Number],
      default: 'default'
    },
    /**
       * 要显示的最大项�?
       */
    maxLength: {
      type: Number,
      default: 0
    },
    //项目总数，用来判断项目太多时显示数字
    listLength:{
      type:Number,
      default:0,
    },
    /**
       * 多余的项目风�?
       */
    excessItemsStyle: {
      type: Object,
      default: () => {
        return {
          color: '#f56a00',
          backgroundColor: '#fde3cf'
        }
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    getItems (items) {
      const classString = {
        [`${this.prefixCls}-item`]: true,
        [`${this.size}`]: true
      }

      if (this.maxLength > 0 && this.listLength > 0 && this.listLength > this.maxLength) {
        items = items.slice(0, this.maxLength)
        items.push((<Avatar size={ this.size } style={ this.excessItemsStyle }>{`+${this.listLength - this.maxLength}`}</Avatar>))
      }
      const itemList = items.map((item) => (
        <li class={ classString }>{ item }</li>
      ))
      return itemList
    }
  },
  render () {
    const { prefixCls, size } = this.$props
    const classString = {
      [`${prefixCls}`]: true,
      [`${size}`]: true
    }
    const items = filterEmpty(this.$slots.default)
    const itemsDom = items && items.length ? <ul class={`${prefixCls}-items`}>{ this.getItems(items) }</ul> : null

    return (
      <div class={ classString }>
        { itemsDom }
      </div>
    )
  }
}
</script>
<style lang="less" scoped>
  @import "../index";

  @avatar-list-prefix-cls: ~"@{ant-pro-prefix}-avatar-list";
  @avatar-list-item-prefix-cls: ~"@{ant-pro-prefix}-avatar-list-item";

  .@{avatar-list-prefix-cls} {
    display: inline-block;

    ul {
      list-style: none;
      display: inline-block;
      padding: 0;
      margin: 0 0 0 8px;
      font-size: 0;
    }
  }

  .@{avatar-list-item-prefix-cls} {
    display: inline-block;
    font-size: @font-size-base;
    margin-left: -8px;
    width: @avatar-size-base;
    height: @avatar-size-base;

    /deep/ .ant-avatar {
      border: 1px solid #fff;
      cursor: pointer;
    }

    &.large {
      width: @avatar-size-lg;
      height: @avatar-size-lg;
    }

    &.small {
      width: @avatar-size-sm;
      height: @avatar-size-sm;
    }

    &.mini {
      width: 20px;
      height: 20px;

      /deep/ .ant-avatar {
        width: 20px;
        height: 20px;
        line-height: 20px;

        .ant-avatar-string {
          font-size: 12px;
          line-height: 18px;
        }
      }
    }
  }


</style>
